import HttpHelpers from './helpers';

const CitiesApiEndpoints = {
  getCities: (params) => {
    return HttpHelpers.unAuthenticatedAxios
      .get('city', { params })
      .then((response) => response.data);
  },
};

export default CitiesApiEndpoints;
